export const removeUndefinedEmptyAndNullValues = (
  obj: Record<string, unknown>
) =>
  Object.entries(obj).reduce((acc: Record<string, unknown>, [key, value]) => {
    if (value !== undefined && value !== '' && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
